/**
 * Chart.js registration - runs once when any chart wrapper is imported.
 * All pages use the wrappers in this folder, so registering once here
 * avoids per-page side-effects. Keep the registered pieces minimal; add
 * more only when a new chart type lands.
 */
import {
  ArcElement,
  BarController,
  BarElement,
  BubbleController,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  LogarithmicScale,
  PieController,
  PointElement,
  PolarAreaController,
  RadarController,
  RadialLinearScale,
  ScatterController,
  Title,
  Tooltip,
  DoughnutController,
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

let registered = false

export function ensureChartsRegistered(): void {
  if (registered) return
  ChartJS.register(
    ArcElement,
    BarController,
    BarElement,
    BubbleController,
    CategoryScale,
    DoughnutController,
    Filler,
    Legend,
    LineController,
    LineElement,
    LinearScale,
    LogarithmicScale,
    PieController,
    PointElement,
    PolarAreaController,
    RadarController,
    RadialLinearScale,
    ScatterController,
    Title,
    Tooltip,
    ChartDataLabels,
  )
  // The datalabels plugin is opt-in per chart via `plugins.datalabels.display`.
  // Set the global default to off so charts that don't configure it stay clean.
  ChartJS.defaults.set('plugins.datalabels', { display: false })
  registered = true
}
